import { render, staticRenderFns } from "./Situacoes.vue?vue&type=template&id=3d6ad522&scoped=true&"
import script from "./Situacoes.vue?vue&type=script&lang=js&"
export * from "./Situacoes.vue?vue&type=script&lang=js&"
import style0 from "./Situacoes.vue?vue&type=style&index=0&id=3d6ad522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ad522",
  null
  
)

export default component.exports